import { Quote } from "lucide-react";
import { TESTIMONIALS } from "./data";
import { Container, MaskText, Reveal, Overline } from "./primitives";

export const Testimonials = () => (
  <section className="bg-[#F4F6FB] py-20 lg:py-32" data-testid="testimonials-section">
    <Container>
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <Overline>Depoimentos</Overline>
          <MaskText className="font-display mt-6 text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#0F172A] sm:text-5xl"
            lines={["O que dizem os líderes", <>que viveram a <span className="text-[#1238CE]">transformação.</span></>]} />
        </div>
        <Reveal className="lg:col-span-4"><p className="text-base leading-relaxed text-slate-600">Empresários e gestores que passaram pelo método e hoje tomam decisões com mais clareza.</p></Reveal>
      </div>
      <div className="mt-14 grid gap-5 md:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={(i % 2) * 0.1}>
            <figure className="group flex h-full flex-col justify-between rounded-[24px] border border-slate-200 bg-white p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(18,56,206,0.35)] sm:p-9" data-testid={`testimonial-card-${i}`}>
              <div>
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="font-display text-2xl font-bold tracking-[-0.02em] text-[#0F172A]" data-testid={`testimonial-company-${i}`}>{t.co}</div>
                    <div className="font-mono-x mt-1 text-xs uppercase tracking-[0.15em] text-[#1238CE]">{t.s}</div>
                  </div>
                  <Quote className="h-8 w-8 shrink-0 text-[#1238CE] transition-transform duration-500 group-hover:-rotate-12" />
                </div>
                <blockquote className="font-display mt-6 text-lg font-medium leading-snug text-[#0F172A] sm:text-xl">“{t.q}”</blockquote>
                <div className="mt-6 flex flex-wrap gap-2">
                  {t.res.map((r) => (
                    <span key={r} className="rounded-full bg-[#CCFF00] px-4 py-2 text-sm font-bold text-[#060B19]" data-testid={`testimonial-result-${i}`}>{r}</span>
                  ))}
                </div>
              </div>
              <figcaption className="mt-8 flex items-center gap-4 border-t border-slate-100 pt-6">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#060B19] font-display text-sm font-bold text-[#CCFF00]">{t.n.replace("Drª. ", "").split(" ").map((w) => w[0]).slice(0, 2).join("")}</span>
                <div>
                  <div className="text-sm font-bold text-[#0F172A]">{t.n}</div>
                  <div className="text-xs text-slate-600">{t.r}</div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </Container>
  </section>
);
